import styled from 'styled-components';

export const Flex = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const FlexItem = styled.div`
  flex-grow: 1;
`;

export const CaptchaContainer = styled.div`
  margin: 16px 0 20px;
`;
